class QuickView extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const quickViewAction = this.querySelector("[data-quickview-action]");

    if (!quickViewAction) return;

    quickViewAction.addEventListener("click", (event) => {
      event.preventDefault();

      const drawer = document.querySelector("#product-quic-kview");

      if (drawer) {
        this.setupEventListener(event, drawer);
      } else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }

  setupEventListener(event, drawer) {
    const selector = ".quickview-body-content";
    const drawerContent = this.querySelector(selector);
    const drawerSelector = document.querySelector(selector);
    const quickViewAction = this.querySelector("[data-quickview-action]");

    if (!drawerSelector || !quickViewAction) return;

    drawerSelector.classList.add("loading");
    drawerSelector.innerHTML = "";

    quickViewAction.classList.add("loading");

    const quickViewIcon = quickViewAction.querySelector(".quick-view-icon");
    const quickViewLoader = quickViewAction.querySelector(".quick-view-loader");

    if (quickViewIcon) {
      quickViewIcon.classList.add("hidden");
    }

    if (quickViewLoader) {
      quickViewLoader.classList.remove("hidden");
    }

    const productUrl = this.dataset.productUrl.split("?")[0];
    const sectionUrl = `${productUrl}?section_id=quick-view`;

    fetch(sectionUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );

        const productElement = responseHTML.querySelector(selector);

        if (!productElement) {
          throw new Error("Quick View turinys nerastas.");
        }

        drawerSelector.innerHTML = productElement.innerHTML;
        drawerSelector.classList.remove("loading");

        drawer.classList.add("active");
        document.body.classList.add("no-scroll");

        quickViewAction.classList.remove("loading");

        if (quickViewIcon) {
          quickViewIcon.classList.remove("hidden");
        }

        if (quickViewLoader) {
          quickViewLoader.classList.add("hidden");
        }

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }


        const mainQuickViewSlider = drawerSelector.querySelector(
          "#main-product-quick-view"
        );

        const mainQuickViewThumbnails = drawerSelector.querySelector(
          "#main-product-thumbnail-quick-view"
        );

if (mainQuickViewSlider) {
  themeSlidersInit(mainQuickViewSlider);
}

if (mainQuickViewThumbnails) {
  themeSlidersInit(mainQuickViewThumbnails);
}


setTimeout(() => {
  if (mainQuickViewSlider && window.Flickity) {
    const mainFlickity = window.Flickity.data(mainQuickViewSlider);

    if (mainFlickity) {
      mainFlickity.resize();
      mainFlickity.reposition();
    }
  }

  if (mainQuickViewThumbnails && window.Flickity) {
    const thumbnailFlickity = window.Flickity.data(
      mainQuickViewThumbnails
    );

    if (thumbnailFlickity) {
      thumbnailFlickity.resize();
      thumbnailFlickity.reposition();
    }
  }
}, 450);


        const featuredQuickViewSlider = drawerSelector.querySelector(
          "#featured-product-quick-view"
        );

        const featuredQuickViewThumbnails = drawerSelector.querySelector(
          "#featured-product-thumbnail-quick-view"
        );

        if (featuredQuickViewSlider) {
          themeSlidersInit(featuredQuickViewSlider);
        }

        if (featuredQuickViewThumbnails) {
          themeSlidersInit(featuredQuickViewThumbnails);
        }

        const code = event.keyCode ? event.keyCode : event.which;

        if (code === 13) {
          setTimeout(() => {
            if (focusElement === "") {
              focusElement = drawerContent;
            }

            trapFocusElements(drawer);
          }, 500);
        }

        if (window.ProductModel) {
          window.ProductModel.loadShopifyXR();
        }
      })
      .catch((error) => {
        console.error(error);

        drawerSelector.classList.remove("loading");
        quickViewAction.classList.remove("loading");

        if (quickViewIcon) {
          quickViewIcon.classList.remove("hidden");
        }

        if (quickViewLoader) {
          quickViewLoader.classList.add("hidden");
        }
      });
  }
}

customElements.define("quick-view", QuickView);